import { Component,Input } from '@angular/core';
import { MostrarProdutoFornecedorComponent } from './views/mostrar-produto-fornecedor/mostrar-produto-fornecedor.component';
import {DadosService} from './db/dados.service'
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireDatabase } from 'angularfire2/database';
import { database } from 'firebase/database';
import { Database } from '@firebase/database';
import {  environment }  from '../environments/environment';
import { UsersService } from '../../models/usuarios.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = environment.site.nome;
  settings = {
    theme: environment.theme
  }
  mensagem = '';
  messagemIndex = -1;
  constructor (
    private fs:AngularFireDatabase, 
    private db: AngularFirestore,
    private dados:DadosService,
    private users:UsersService){
    
    users.validaLoginLocal();

    setInterval(()=>{
      var s = this.mensagens;
      this.messagemIndex ++;
      if (this.messagemIndex>=s.length){
        this.messagemIndex=0;
      }
      if (this.messagemIndex<s.length)
      { 
         this.mensagem = s[this.messagemIndex];
      }
   },30000);

   this.test();
  }

  @Input()
  get mensagens(){
   return  this.dados.mensagensRodape;
  }


  test(){
//    console.log('test');
/*    var citiesRef = this.db.collection("cities");

citiesRef.doc("SF").set({
    name: "San Francisco", state: "CA", country: "USA",
    capital: false, population: 860000 });
citiesRef.doc("LA").set({
    name: "Los Angeles", state: "CA", country: "USA",
    capital: false, population: 3900000 });
citiesRef.doc("DC").set({
    name: "Washington, D.C.", state: null, country: "USA",
    capital: true, population: 680000 });
citiesRef.doc("TOK").set({
    name: "Tokyo", state: null, country: "Japan",
    capital: true, population: 9000000 });
citiesRef.doc("BJ").set({
    name: "Beijing", state: null, country: "China",
    capital: true, population: 21500000 });
*/
/*
// Create a reference to the cities collection
var citiesRef = this.db.collection("cities").ref;
// Create a query against the collection.
var query = citiesRef.where("state", "==", "CA");
  query.get().then(docs=>{
    let arr=[];
    docs.forEach(element => {
       arr.push({id:element.id,...element.data()});
    });
    console.log(arr);
  })

 var pRef = this.db.collection("nc-produtos").ref;
 var query = pRef.where("codigo","==","1");
 query.get().then(docs=>{
   let arr=[]; 
  docs.forEach(element => {
     arr.push({id:element.id,...element.data()});
   });
   console.log(arr);
 })


 this.fs.list('cities').valueChanges().subscribe(d=>{console.log(d)});


 var docRef = this.db.collection("cities").doc("SF").ref;

 docRef.get().then(function(doc) {
     if (doc.exists) {
         console.log("Document data:", doc.data());
     } else {
         // doc.data() will be undefined in this case
         console.log("No such document!");
     }
 }).catch(function(error) {
     console.log("Error getting document:", error);
 });
*/

}  



}
